<div class="container">
  <h2 class="main-title beta" fiTranslation="USER_PROFILE_ADMINISTRATION"></h2>
  <div class="tabs">
    <mat-tab-group class="tabs-inner" [(selectedIndex)]="activeTab"
      [disableRipple]="true"
      (selectedIndexChange)="onTabChange($event)">
      <mat-tab>
        <ng-template mat-tab-label>
          <span fiTranslation="ADMINISTRATION_TAB_OU"></span>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span fiTranslation="ADMINISTRATION_TAB_AREA"></span>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span fiTranslation="ADMINISTRATION_TAB_DUPLICATES"></span>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>

  @if (activeTab === 0) {
    <fi-organizational-units [mandant]="mandant"></fi-organizational-units>
  }
  @if (activeTab === 1) {
    <fi-areas [mandant]="mandant"></fi-areas>
  }
  @if (activeTab === 2) {
    <fi-duplicates [mandant]="mandant"></fi-duplicates>
  }
</div>
